import React from "react";

// Applies To: System / Entire Organization / Selected Group(s). "All" is only a viewing filter and is never stored.
export function ScopeSelector({ value, onChange, groups = [], orgGroupCount = 0, canSystem = false, testPrefix = "scope" }) {
  const sel = value.organization_ids || [];
  const tog = (id) => onChange({ scope_type: "group", organization_ids: sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id] });
  const allPicked = value.scope_type === "group" && orgGroupCount > 1 && sel.length >= orgGroupCount;
  const opt = (k, l) => (
    <label className="inline-flex items-center gap-1.5 text-sm cursor-pointer">
      <input type="radio" checked={value.scope_type === k} onChange={() => onChange({ scope_type: k, organization_ids: k === "group" ? sel : [] })} data-testid={`${testPrefix}-${k}`} />{l}
    </label>);
  return (
    <div className="space-y-1.5" data-testid={`${testPrefix}-selector`}>
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        {canSystem && opt("system", "ALL Groups")}
        {opt("account", "Entire Organization")}
        {groups.length > 0 && opt("group", "Selected Group(s)")}
      </div>
      {value.scope_type === "group" && (
        <div className="flex flex-wrap gap-x-4 gap-y-1 pl-5">
          {groups.map((g) => <label key={g.id} className="inline-flex items-center gap-1.5 text-xs"><input type="checkbox" checked={sel.includes(g.id)} onChange={() => tog(g.id)} data-testid={`${testPrefix}-group-${g.id}`} />{g.name}</label>)}
        </div>)}
      {allPicked && (
        <div className="text-xs rounded border border-amber-200 bg-amber-50 text-amber-800 px-2 py-1 flex items-center gap-2" data-testid={`${testPrefix}-use-org-hint`}>
          Every Group is selected.
          <button type="button" className="font-semibold underline" onClick={() => onChange({ scope_type: "account", organization_ids: [] })} data-testid={`${testPrefix}-use-org`}>Use Entire Organization instead</button>
        </div>)}
    </div>
  );
}
